<div class="notifier"  [ngStyle]="{'background-color': data.bg}" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()" data-test="snackbar">
    <div class="notifier__content-box">
        <div class="notifier__icon-wrapper">
            <div
                class="notifier__icon"
                [ngClass]="{
                    error: data.status == 'error' || data.status === 'delete' || data.status === 'calendar-error',
                    info: data.status == 'info' || data.status === 'resync',
                    warning: data.status == 'warning',
                    deleted: data.status == 'deleted',
                    success: data.status == 'success' || data.status === 'archive' || data.status === 'acknowledge' || data.status === 'resolve' || data.status === 'watcher' || data.stauts === 'copy' || data.status === 'calendar-success' || data.status === 'icon-edit-success'
                }"
            >
                <span
                    [ngClass]="{
                        'icon-inbox': data.status == 'archive',
                        'icon-check': data.status == 'success',
                        'icon-x': data.status == 'error',
                        'icon-info': data.status == 'info',
                        'icon-alert-circle': data.status == 'warning',
						'icon-trash-2': data.status == 'deleted' || data.status === 'delete',
						'icon-thumbs-up': data.status === 'acknowledge',
						'icon-check-circle-fill': data.status === 'resolve',
						'icon-eye': data.status === 'watcher',
                        'icon-refresh-cw': data.status === 'resync',
                        'icon-copy': data.status === 'copy',
                        'icon-calendar': data.status === 'calendar-error' || data.status === 'calendar-success',
                        'icon-edit': data.status === 'icon-edit-success'
                    }"
                    [attr.data-test]="data.status">
                </span>
            </div>
        </div>
        <span class="notifier__text" data-test="notifier-text" [innerHTML]="data.text"></span>
    </div>
    <div class="notifier__btn-box" *ngIf="showButton">
        <button data-test="snackbar-btn" mat-button color="primary" (click)="onClickBtn()">
            {{ textButton }}
        </button>
    </div>
</div>
